var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5523_37958)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33594 10.0007H2.66927C2.31565 10.0007 1.97651 9.86018 1.72646 9.61013C1.47641 9.36008 1.33594 9.02094 1.33594 8.66732V2.66732C1.33594 2.3137 1.47641 1.97456 1.72646 1.72451C1.97651 1.47446 2.31565 1.33398 2.66927 1.33398H8.66927C9.02289 1.33398 9.36203 1.47446 9.61208 1.72451C9.86213 1.97456 10.0026 2.3137 10.0026 2.66732V3.33398M7.33594 6.00065H13.3359C14.0723 6.00065 14.6693 6.5976 14.6693 7.33398V13.334C14.6693 14.0704 14.0723 14.6673 13.3359 14.6673H7.33594C6.59956 14.6673 6.0026 14.0704 6.0026 13.334V7.33398C6.0026 6.5976 6.59956 6.00065 7.33594 6.00065Z",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5523_37958"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIco);
export default __webpack_public_path__ + "static/media/copy_ico.c5b57f25547c91b0014b3a9d65e6f2c4.svg";
export { ForwardRef as ReactComponent };